import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Box,
  InputAdornment
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

const defaultCliente = {
  nome: '',
  cpf: '',
  rg: '',
  data_nascimento: null,
  telefone: '',
  email: '',
  cep: '',
  logradouro: '',
  numero: '',
  complemento: '',
  bairro: '',
  cidade: '',
  estado: '',
  empresa: '',
  telefone_comercial: '',
  cargo: '',
  renda_mensal: '',
  referencia_name1: '',
  referencia_telefone1: '',
  referencia_name2: '',
  referencia_telefone2: '',
  referencia_name3: '',
  referencia_telefone3: ''
};

export default function ClienteDialog({ open, handleClose, handleSave, cliente = defaultCliente, setCliente, fullScreen = false }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCliente(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDateChange = (date) => {
    setCliente(prev => ({
      ...prev,
      data_nascimento: date
    }));
  };

  const handleMoneyChange = (e) => {
    let value = e.target.value;
    // Remove tudo exceto números e vírgula
    value = value.replace(/[^\d,]/g, '');
    
    // Garante apenas uma vírgula
    const parts = value.split(',');
    if (parts.length > 2) {
      value = parts[0] + ',' + parts[1];
    }
    
    // Limita a 2 casas decimais
    if (parts.length === 2 && parts[1].length > 2) {
      value = parts[0] + ',' + parts[1].slice(0, 2);
    }

    setCliente(prev => ({
      ...prev,
      renda_mensal: value
    }));
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      maxWidth="md" 
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          m: { xs: 0, sm: 2 },
          height: { xs: '100%', sm: 'auto' },
          borderRadius: { xs: 0, sm: 2 },
          overflowX: 'hidden'
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          position: fullScreen ? 'sticky' : 'static', 
          top: 0, 
          zIndex: 1,
          backgroundColor: 'background.paper',
          borderBottom: fullScreen ? '1px solid rgba(0, 0, 0, 0.12)' : 'none'
        }}
      >
        {cliente?.id ? 'Editar Cliente' : 'Novo Cliente'}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ p: { xs: 1, sm: 2 } }}>
          <Grid container spacing={{ xs: 1.5, sm: 2 }}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nome"
                name="nome"
                value={cliente?.nome || ''}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="CPF"
                name="cpf"
                value={cliente?.cpf || ''}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="RG"
                name="rg"
                value={cliente?.rg || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <DatePicker
                label="Data de Nascimento"
                value={cliente?.data_nascimento || null}
                onChange={handleDateChange}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Telefone"
                name="telefone"
                value={cliente?.telefone || ''}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={cliente?.email || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="CEP"
                name="cep"
                value={cliente?.cep || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Logradouro"
                name="logradouro"
                value={cliente?.logradouro || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Número"
                name="numero"
                value={cliente?.numero || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label="Complemento"
                name="complemento"
                value={cliente?.complemento || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Bairro"
                name="bairro"
                value={cliente?.bairro || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Cidade"
                name="cidade"
                value={cliente?.cidade || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Estado"
                name="estado"
                value={cliente?.estado || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Empresa"
                name="empresa"
                value={cliente?.empresa || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Telefone Comercial"
                name="telefone_comercial"
                value={cliente?.telefone_comercial || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Cargo"
                name="cargo"
                value={cliente?.cargo || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Renda Mensal"
                name="renda_mensal"
                value={cliente?.renda_mensal || ''}
                onChange={handleMoneyChange}
                InputProps={{
                  startAdornment: <InputAdornment position="start">R$</InputAdornment>
                }}
              />
            </Grid>
            {/* Referências */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nome da Referência 1"
                name="referencia_name1"
                value={cliente?.referencia_name1 || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Telefone da Referência 1"
                name="referencia_telefone1"
                value={cliente?.referencia_telefone1 || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nome da Referência 2"
                name="referencia_name2"
                value={cliente?.referencia_name2 || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Telefone da Referência 2"
                name="referencia_telefone2"
                value={cliente?.referencia_telefone2 || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nome da Referência 3"
                name="referencia_name3"
                value={cliente?.referencia_name3 || ''}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Telefone da Referência 3"
                name="referencia_telefone3"
                value={cliente?.referencia_telefone3 || ''}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">Cancelar</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}